"use client";

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  CreateAiIntegrationData,
  CreateAiIntegrationFormSchema,
} from "./schema";
import { useToast } from "@/hooks/use-toast";
import hooks from "@/hooks";
import { Form } from "@/components/ui/form";
import FormFields from "../Fields";
import Buttons from "@/components/core/Buttons";

interface ICreateAiIntegrationFormProps {
  onSuccess?: () => void;
}

const CreateAiIntegrationForm = ({
  onSuccess,
}: ICreateAiIntegrationFormProps) => {
  const { toast } = useToast();

  const form = useForm<CreateAiIntegrationData>({
    resolver: zodResolver(CreateAiIntegrationFormSchema),
    defaultValues: {
      name: "",
      integration_key: "",
      type: undefined,
    },
  });

  const createIntegrationService = hooks.useCreateAiIntegration({
    onSuccess: () => {
      toast({
        title: "Integração criada com sucesso!",
        variant: "success",
      });
      if (onSuccess) onSuccess();
    },
    onError: (error: unknown) => {
      toast({
        title: "Não foi possível criar integração",
        description: (error as Error).message,
        variant: "warning",
      });
    },
  });

  async function onSubmit(data: CreateAiIntegrationData) {
    await createIntegrationService.mutateAsync(data);
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="w-full flex flex-col items-center gap-y-6"
      >
        <FormFields.InputFormField
          form={form}
          formName="name"
          placeholder="Insira o nome da integração"
          label="Nome da integração"
        />

        <FormFields.InputFormField
          form={form}
          formName="integration_key"
          label="Credencial"
          placeholder="Insira a credencial da integração"
          type="password"
        />

        <FormFields.SelectFormField
          form={form}
          formName="type"
          label="Tipo"
          placeholder="Selecione o tipo"
          options={[
            { label: "OPEN AI", value: "OPEN_AI" },
            { label: "TWILIO", value: "TWILIO" },
          ]}
        />

        <Buttons.DefaultButton
          className="py-6"
          type="submit"
          title="Salvar Integração"
          isLoading={createIntegrationService.isPending}
        />
      </form>
    </Form>
  );
};

export default CreateAiIntegrationForm;
